import React, { useState, useEffect } from "react";
import { doc, setDoc, deleteDoc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import Cookies from "js-cookie";
import { BsBookmarkStar,BsBookmarkStarFill } from "react-icons/bs";
// Generate guestId if not in localStorage
function getGuestId() {
  let guestId = localStorage.getItem("guestId");
  if (!guestId) {
    guestId = "guest_" + Math.random().toString(36).substring(2, 12);
    localStorage.setItem("guestId", guestId);
  }
  return guestId;
}

export default function Saved({ product }) {
  const [isSaved, setIsSaved] = useState(false);
  const [guestId, setGuestId] = useState(getGuestId());

  // Determine product uid
  const productUid = typeof product === "string" ? product : product?.uid;

  useEffect(() => {
    // Update guestId if sessiontoken exists
    const sessionToken = Cookies.get("sessiontoken");
    const guid = Cookies.get("guid");
    if (sessionToken && guid) {
      setGuestId(guid);
    }
  }, []);

  useEffect(() => {
    if (!productUid || !guestId) return;

    const checkSaved = async () => {
      try {
        const savedRef = doc(db, "products_saved", guestId, "items", productUid);
        const savedSnap = await getDoc(savedRef);
        setIsSaved(savedSnap.exists());
      } catch (err) {
        console.error("Error checking saved:", err);
     //   alert("Error checking saved product!");
      }
    };

    checkSaved();
  }, [productUid, guestId]);

  const toggleSave = async () => {
    if (!productUid || !guestId) return;

    const savedRef = doc(db, "products_saved", guestId, "items", productUid);

    try {
      if (isSaved) {
        await deleteDoc(savedRef);
        setIsSaved(false);
       // alert("Removed from saved products!");
      } else {
        await setDoc(savedRef, {
          uid: productUid,
          createdAt: new Date(),
        });
        setIsSaved(true);
       // alert("Product saved successfully!");
      }
    } catch (err) {
      console.error("Error saving product:", err);
    //  alert("Error saving product!");
    }
  };

  return (
    <div onClick={toggleSave}  className="button-ui1 p-0 cursor">
      {isSaved ? (
        <BsBookmarkStarFill title="Saved" className="icon green" size={20} />
      ) : (
        <BsBookmarkStar title="Save" className="icon" size={20} />
      )}    
    </div>
  );
}
